export const ADMIN_API = {
  LOGIN: "login",
  GET_ROLE: "getRole",
  CHANGE_PASSWORD: "changePassword",
  DOWN_LINE_LIST: "downLineList",
  PLAYER_CREATE: "downLineList/player/create",
  PLAYER_GET_PROFILE: "downLineList/player/getProfile",
  PLAYER_BET_HISTORY: "downLineList/player/betHistory",
  PLAYER_BET_CURRENT: "downLineList/player/betCurrent",
  PLAYER_CASINO_BET_HISTORY: "downLineList/player/casinoHistory",
  PLAYER_CASINO_AG_BET_HISTORY: "downLineList/player/casinoBetHistory",
  PLAYER_PROFIT_LOSS: "downLineList/player/getProfitLoss",
  AGENT_PROFIT_LOSS: "downLineList/agent/getProfitLoss",
  PLAYER_BET_LIST: "downLineList/player/getBetList",
  PLAYER_BET_LIST_CHEATS: "sports/getCheatsBets",
  PLAYER_ACTIVE: "downLineList/player/active",
  AGENT_CREATE: "downLineList/agent/create",
  AGENT_UPDATE_INFO: "downLineList/agent/updateInfo",
  AGENT_CHANGE_CASINO: "downLineList/agent/changeCasino",
  PLAYER_UPDATE_INFO: "downLineList/player/updateInfo",
  PLAYER_CHANGE_CASINO: "downLineList/player/changeCasino",
  PLAYER_BLOCK: "downLineList/player/cheatBlock",
  PLAYER_RISK_BET_HISTORY: "downLineList/player/riskBetHistory",
  AGENT_GET_LIST: "downLineList/agent/getList",
  CREDIT_REF: "downLineList/addCreditRef",
  SPORTS_LIMIT: "downLineList/addSportLimit",
  REPORT: {
    DOWN_LINE: "report/downline",
    MARKET_REPORT: "report/marketReport",
    PL_MARKET_REPORT: "report/profitLossByMarket",
    NEW_MARKET_REPORT: "report/marketReportNew",
    DOWN_LINE_CASINO: "report/downlineCasino",
    ACCOUNT_STATEMENT: "report/accountStatment",
    USER_LIST: "report/userList",
    STATEMENT_BET_VIEW: "myAccount/statementBetView",
    DW: "report/deposit-withdrawal",
    SPORTS_PROFIT_LOST: "report/sportsProfitLost",
    CASINO_PROFIT_LOST: "report/casinoProfitLost",
    LIFETIME_BALANCE: "report/lifetime-balance",
    SHOW_PROVIDER_PL: "report/showProviderPL",
  },
  MY_ACCOUNT: {
    GET_PROFILE: "myAccount/getProfile",
    GET_ACTIVITIES: "myAccount/getActivities",
    GET_STATEMENTS: "myAccount/getStatements",
    UPDATE_CONTACT: "downLineList/agent/updateInfo",
  },
  BET_LIST: {
    LIST_LIVE: "betList/liveList",
    LIST: "betList/list",
    MATCH_LIST: "betList/matchList",
    VOID: "betList/voidBets",
  },
  RISK: "risk",
  RISK_BET_LIST: "risk/getBetList",
  RISK_DELETE_BET: "risk/deleteBet",
  RISK_GET_BLOCK: "risk/getBlockMatch",
  RISK_UPDATE_BLOCK: "risk/blockMatch",
  RISK_ADMIN_BOOK_LIST: "risk/getBetListAdminBook",
  RISK_TOP20: "risk/getListOfBetBigAmount",
  RISK_BY_MARKET: "risk/getListByMarket",
  RISK_DASHBOARD: "risk/getDashboard",
  RISK_EVENT_SELECTION_AMOUNT: "risk/getEventSelectionMatchAmount",
  RISK_DOWNLINE_PL: "risk/getDownlinePL",
  RISK_FANCY_RUN_POSITION: "risk/getFancyRunPosition",
  RISK_PREMIUM_BOOK_POSITION: "risk/getPremiumBookPosition",
  BANKING: {
    GET_BALANCE: "banking/master/getBalance",
    ADD_BALANCE: "banking/master/addBalance",
    GET_LIST: "banking/getList",
    UPDATE: "banking/update",
    METHODS: {
      GET_ALL: "banking/method/getAll",
      GET_ONE: "banking/method/getOne",
      UPDATE: "banking/method/updateMethod",
      ADD: "banking/method/add",
    },
  },
  PRIVILEGES: {
    GET: "privileged/getUserRole",
    UPDATE: "privileged/updateUserRole",
  },
  MARKET: {
    LIST: "market/list",
    BLOCK: "market/block",
  },
  SPORTS: {
    LIST: "sports/getList",
    ACTIVE_SPORT: "sports/activeSport",
    REMOVE_SPORT: "sports/removeSport",
  },
  ONLINE_PAYMENT: {
    // onlinePayment/deposit/getList
    DEPOSIT: {
      GET_LIST: "onlinePayment/deposit/getList",
      APPROVE_DEPOSIT: "onlinePayment/deposit/approveDeposit",
      APPROVE_DEPOSIT_ADMIN: "onlinePayment/deposit/approveDepositAdmin",
    },
    WITHDRAW: {
      GET_LIST: "onlinePayment/withdrawal/getList",
      APPROVE_WITHDRAW: "onlinePayment/withdrawal/approveWithdrawal",
      APPROVE_WITHDRAW_ADMIN: "onlinePayment/withdrawal/approveWithdrawalAdmin",
    },
    ADD_REQUEST: {
      ADD_DEPOSIT: "onlinePayment/addRequest/addDeposit",
      ADD_WITHDRAWAL: "onlinePayment/addRequest/addWithdrawal",
      GET_METHOD: "onlinePayment/addRequest/getMethod",
      GET_TRANSACTIONS: "onlinePayment/addRequest/getMyTransactions",
    },
    SBKASH: {
      GET_LIST: "sbkash/getList",
    },
  },
  OPS: {
    LOGS: "ops/logs",
    LOGS_DELETE: "ops/logs/delete",
    CRON_LOGS_DELETE: "ops/cron/logs/delete",
    TRACE: "ops/trace",
    MONEY_EVENTS: "ops/money-events",
    DRIFT: "ops/drift",
    JOBS: "ops/jobs",
  },
  SECURITY: {
    BLOCKED_IPS: "security/blockedIps",
    ALLOWED_IPS: "security/allowedIps",
    BLOCK_IP: "security/blockIp",
    UNBLOCK_IP: "security/unblockIp",
    ALLOW_IP: "security/allowIp",
    REVOKE_ALLOW_IP: "security/revokeAllowIp",
  },
  SETTING: {
    USERS: {
      GET_USER_COUNT: "totalPlayerCount",
      GET_USER_LIST_BY_DOWNLINE: "getUserListByDownline",
      GET_USER_AUDIT: "getUserAudit",
      FIX_USER_EXPOSURE: "fixUserExposure",
      FIX_ALL_USER_EXPOSURE: "fixAllUserExposure",
      GET_USER_TAB_DATA: "getUserTabData",
      GET_EXPOSURE_AUDIT_LINEAGE: "getExposureAuditLineage",
      SCAN_EXPOSURE_AUDIT_LINEAGE: "scanExposureAuditLineage",
      DELETE_UNSETTLED_CASINO_BET: "deleteUnsettledCasinoBet",
      SEARCH_USERS: "searchUsers",
      GET_USER_DETAIL: "getUserDetail",
      UPDATE_USER_DETAIL: "updateUserDetail",
      GET_WEBSITES_LIST: "getWebsitesList",
      FORCE_LOGOUT_USER: "forceLogoutUser",
    },
    BANNER: {
      GET_LIST: "setting/banner",
      GET_ONE: "setting/banner/getOne",
      CREATE: "setting/banner/create",
      UPDATE: "setting/banner/update",
      DELETE: "setting/banner/delete",
    },
    DASHBOARD: {
      GET_LIST: "setting/dashboard",
      CLONE: 'setting/dashboard/clone',
      GET_ONE: "setting/dashboard/getOne",
      CREATE: "setting/dashboard/create",
      UPDATE: "setting/dashboard/update",
      DELETE: "setting/dashboard/delete",
      CATALOG_SYNC: "setting/dashboard/catalog/sync",
      CATALOG_STATUS: "setting/dashboard/catalog/status",
      CATALOG_SEARCH: "setting/dashboard/catalog/search",
      CATALOG_COPY_IMAGE: "setting/dashboard/catalog/copyImage",
      REORDER: "setting/dashboard/reorder",
      REORDER_INIT: "setting/dashboard/reorder/init",
    },
    MANAGE_CASINO: {
      GET_LIST: "setting/manageCasino",
      CREATE: "setting/manageCasino/create",
      UPDATE: "setting/manageCasino/update",
      GET_ONE: "setting/manageCasino/getOne",
      TOGGLE_STATUS: "setting/manageCasino/toggleStatus",
    },
    PREMIUM_HISTORY: {
      GET_LIST: "setting/premiumHistory",
      LIST_OF_BET: "setting/premiumHistory/listOfBet",
      ROLL_BACK_WINNER: "setting/premiumHistory/rollBackWinner",
    },
    FANCY_HISTORY: {
      GET_LIST: "setting/fancyHistory",
      LIST_OF_BET: "setting/fancyHistory/listOfBet",
      ROLL_BACK_WINNER: "setting/fancyHistory/rollBackWinner",
      LIST_OF_BET_CANCEL: "setting/fancyHistory/listOfBetCancel",
    },
    MANAGE_PREMIUM: {
      GET_LIST: "setting/managePremium",
      LIST_OF_BET: "setting/managePremium/listOfBet",
      DECLARE_WINNER: "setting/managePremium/declareWinner",
    },
    MANAGE_FANCY: {
      GET_LIST: "setting/manageFancy",
      LIST_OF_BET: "setting/manageFancy/listOfBet",
      DECLARE_WINNER: "setting/manageFancy/declareWinner",
    },
    MATCH_HISTORY: {
      GET_LIST: "setting/matchHistory",
      ROLL_BACK_WINNER: "setting/matchHistory/rollBackWinner",
      LIST_OF_CANCEL_MATCH: "setting/matchHistory/listOfCancel",
    },
    SPORT_MARKET: {
      GET_LIST: "sports/sportMarket",
      GET_LIST_PLACE_BET: "sports/sportMarketPlacedBet",
      DECLARE_WINNER: "sports/declareWinner",
      UPDATE: "sports/updare",
      UPDATE_PROFIT_LIMIT: "sports/updateProfitLimit",
      GET_SPORT_USERS_COUNT: "sports/getUserCount",
      GET_SPORT_BETS_COUNT: "sports/getBetsCount",
      GET_LAST_WEEK_SPORTS_LIST: "sports/getLastWeekSportsList",
      GET_NEXT_2DAYS_SPORTS_LIST: "sports/getNextTwoDaysSportsList"
    },
    WEBSITE: {
      ADD: "setting/website/addWebSite",
      CREATE: "setting/website",
      UPDATE: "setting/website/update",
      UPDATE_LINKS: "setting/website/updateLinks",
      GET_SITE: "setting/website/getSite",
      GET_SITE_BY_ID: "setting/website/getSiteById",
      LIST: "setting/website/list",
      MAINTENANCE: "setting/website/maintenance",
      MAINTENANCE_BULK: "setting/website/maintenanceBulk",
      GET_DOMAIN: "setting/website/getDomain",
      ACTIVE: "setting/website/activeDeactiveSite",
      DELETE: "setting/website/delete",
      IN_ACTIVE_LIST: "setting/website/getInactiveDomain",
      GET_SPORTS_LIMIT: "setting/website/getSportsLimit",
      UPDATE_SPORTS_LIMIT: "setting/website/updateSportsLimit",
    },
    FILE_UPLOAD: "setting/fileUpload",
    WHITELABLELIMIT: {
      GET_AGENT_LIST: "setting/whiteLabelsLimit/getAgentList",
      GET: "setting/whiteLabelsLimit/getLimit",
      UPDATE: "setting/whiteLabelsLimit/updateLimit",
      RESET: "setting/whiteLabelsLimit/resetLimit",
      TOPUP: "setting/whiteLabelsLimit/topUpLimit",
      ALLOCATE: "setting/whiteLabelsLimit/allocateLimit",
      SET_SUPER_ADMIN: "setting/whiteLabelsLimit/setSuperAdminLimit",
      HISTORY: "setting/whiteLabelsLimit/getLimitHistory",
    },
    CONTACT_DETAILS: {
      GET: "setting/contactDetails",
      UPDATE: "setting/contactDetails/updateDetails",
    },
  },
  ANALYTICS: "analytics/stats",
  ANALYTICS_ONLINE: "analytics/online",
};

export const PAGINATION_LIMIT = 50;

export const THEME_OPTION = [
  { label: "Sky-Sky", value: "sky-sky" },
  { label: "Velki", value: "velki" },
];

export const COLOR_OPTION = [
  {
    backgroundColor: "#ffcc2f",
    color: "#222",
    activeMenuColor: "#FFDE7D",
    label: "Yellow",
    value: "yellow",
  },
  {
    backgroundColor: "#67f0c2",
    color: "#222",
    activeMenuColor: "#1db87a",
    label: "Onsen",
    value: "onsen",
  },
  {
    backgroundColor: "#291e39",
    color: "#FFF",
    activeMenuColor: "#4a3075",
    label: "Purple",
    value: "purple",
  },
  {
    backgroundColor: "#f00201",
    color: "#FFF",
    activeMenuColor: "#a01a12",
    label: "Red",
    value: "red",
  },
  {
    backgroundColor: "#5D6699",
    color: "#000",
    activeMenuColor: "#3a4a7a",
    label: "Blue",
    value: "blue",
  },
  {
    backgroundColor: "#000000",
    color: "#FFF",
    activeMenuColor: "#333333",
    label: "Black",
    value: "black",
  },
  {
    backgroundColor: "#FF3377",
    color: "#FFF",
    activeMenuColor: "#cc0055",
    label: "Pink",
    value: "pink",
  },
  {
    backgroundColor: "#FFFEBB",
    color: "#000",
    activeMenuColor: "#c9a800",
    label: "Light Yellow",
    value: "light-yellow",
  },
  {
    backgroundColor: "#FF8C00",
    color: "#FFF",
    activeMenuColor: "#cc5500",
    label: "Dark Orange",
    value: "dark-orange",
  },
  {
    backgroundColor: "#FFB80C",
    color: "#000",
    activeMenuColor: "#FFDE7D",
    label: "Gold",
    value: "gold",
  },
  {
    backgroundColor: "#0CFE09",
    color: "#313131",
    activeMenuColor: "#07b505",
    label: "Radioactive Green",
    value: "radioactive-green",
  },
  {
    backgroundColor: "#708090",
    color: "#000",
    activeMenuColor: "#4a5568",
    label: "Slategrey",
    value: "slategrey",
  },
  {
    backgroundColor: "#0D4F8B",
    color: "#FFF",
    activeMenuColor: "#083a6b",
    label: "Indigo Dye",
    value: "indigo-dye",
  },
  {
    backgroundColor: "#428139",
    color: "#FFF",
    activeMenuColor: "#2a5724",
    label: "Green",
    value: "green",
  },
  {
    backgroundColor: "#012525",
    color: "#FFF",
    activeMenuColor: "#001515",
    label: "Burnham",
    value: "burnham",
  },
  {
    backgroundColor: "#00A884",
    color: "#000",
    activeMenuColor: "#007a5e",
    label: "Persian Green",
    value: "persian-green",
  },
  {
    backgroundColor: "#51e2f5",
    color: "#000",
    activeMenuColor: "#0bb5cc",
    label: "Electric Blue",
    value: "electric-blue",
  },
  {
    backgroundColor: "#0047ab",
    color: "#FFF",
    activeMenuColor: "#002f7a",
    label: "Dark Royal Blue",
    value: "dark-royal-blue",
  },
  {
    backgroundColor: "#ff00a9",
    color: "#FFF",
    activeMenuColor: "#bb007d",
    label: "pinkish purple",
    value: "pinkish-purple",
  },
  {
    backgroundColor: "#099",
    color: "#FFF",
    activeMenuColor: "#006666",
    label: "Dark Cyan",
    value: "Dark-Cyan",
  },
];



